import React from 'react';

export interface EfficiencyIconProps {
  className?: string;
}

export const EfficiencyIcon: React.FC<EfficiencyIconProps> = () => {
  return (
    <svg width="38" height="38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.226 24.146v-1.933h-5.38v-1.948h3.994l-3.61-3.578 1.39-1.378 3.606 3.574v-5.575h1.966v5.59l3.607-3.578 1.389 1.378-3.596 3.567h3.986v1.948h-5.386v1.933h-1.966z"
        fill="#36DC90"
      />
      <ellipse
        cx="18.977"
        cy="18.963"
        rx="16.977"
        ry="16.963"
        stroke="#F0EEEB"
        strokeWidth="3.298"
      />
      <path
        d="M2 18.963c0 9.368 7.6 16.962 16.977 16.962 9.376 0 16.976-7.594 16.976-16.962C35.953 9.594 28.353 2 18.977 2"
        stroke="url(#prefix__a)"
        strokeWidth="3.298"
      />
      <defs>
        <linearGradient
          id="prefix__a"
          x1="25.938"
          y1="2"
          x2="-0.679"
          y2="8.903"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#36DC90" />
          <stop stopColor="#36DC90" />
          <stop offset="1" stopColor="#CEB9F3" />
        </linearGradient>
      </defs>
    </svg>
  );
};
